module.exports = __webpack_public_path__ + "favicon/favicon-32x32.png";